'use strict';

/**
 * Lazy load newsletter signup videos - start playing when scrolled into view
 */
(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const newsletterSignup = document.querySelector('.newsletter-signup');
    if (!newsletterSignup) {
      return;
    }

    const videos = newsletterSignup.querySelectorAll('video[data-lazy-autoplay]');
    if (videos.length === 0) {
      return;
    }

    function playVideo(video) {
      video.play().catch(err => {
        // Handle autoplay restrictions
        console.warn('Video autoplay prevented:', err);
      });
    }

    // Use Intersection Observer for better performance
    const observerOptions = {
      root: null, // viewport
      rootMargin: '100px', // start loading 100px before entering viewport
      threshold: 0.1 // trigger when 10% visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;

        if (entry.isIntersecting) {
          // Video is near viewport, start playing
          if (video.paused && !video.ended && !video.dataset.userPaused) {
            video.setAttribute('autoplay', '');
            playVideo(video);
            // Once video starts playing, we can disconnect the observer
            observer.unobserve(video);
          }
        }
      });
    }, observerOptions);

    // Observe all videos in the newsletter signup section
    videos.forEach(video => {
      observer.observe(video);
    });

    // Pause/play toggle: acts on all videos in the visual (mobile + desktop variants)
    const pauseToggle = newsletterSignup.querySelector('.newsletter-signup-visual-pause-toggle');
    if (pauseToggle) {
      pauseToggle.addEventListener('click', () => {
        const visual = pauseToggle.closest('.newsletter-signup-visual');
        const visualVideos = visual.querySelectorAll('video');
        const shouldPause = !pauseToggle.classList.contains('paused');

        pauseToggle.classList.toggle('paused', shouldPause);
        visualVideos.forEach(video => {
          if (shouldPause) {
            video.dataset.userPaused = 'true';
            video.pause();
          } else {
            delete video.dataset.userPaused;
            // Only resume the video that is actually displayed (mobile or desktop)
            if (video.offsetParent !== null) {
              playVideo(video);
            }
          }
        });
        pauseToggle.setAttribute('aria-pressed', shouldPause ? 'true' : 'false');
      });
    }

    // Also handle visibility change (when user switches tabs)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        // Pause videos when tab is hidden
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
          }
        });
      } else if (document.visibilityState === 'visible') {
        // Resume videos that are in viewport when tab becomes visible
        videos.forEach(video => {
          const rect = video.getBoundingClientRect();
          const isInViewport = rect.top < window.innerHeight + 100 && rect.bottom > -100;
          if (isInViewport && video.paused && video.hasAttribute('data-lazy-autoplay') && !video.ended && !video.dataset.userPaused) {
            playVideo(video);
          }
        });
      }
    });
  }
})();

